interface WarningAccountIconProps {
  width?: number;
  height?: number;
  viewBox?: string;
  fill?: string;
  className?: string;
}

const WarningAccountIcon = ({
  width = 18,
  height = 19,
  viewBox = '0 0 18 19',
  fill = 'var(--warning-text-on-muted)',
  className,
}: WarningAccountIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    className={className}
    data-palette="WarningAccountIcon">
    <path
      d="M3.35259 15.8778H14.6476C15.8026 15.8778 16.5226 14.6253 15.9451 13.6278L10.2976 3.87032C9.72009 2.87282 8.28009 2.87282 7.70259 3.87032L2.05509 13.6278C1.47759 14.6253 2.19759 15.8778 3.35259 15.8778ZM9.00009 10.6278C8.58759 10.6278 8.25009 10.2903 8.25009 9.87782V8.37782C8.25009 7.96532 8.58759 7.62782 9.00009 7.62782C9.41259 7.62782 9.75009 7.96532 9.75009 8.37782V9.87782C9.75009 10.2903 9.41259 10.6278 9.00009 10.6278ZM9.75009 13.6278H8.25009V12.1278H9.75009V13.6278Z"
      fill={fill}
    />
  </svg>
);

export default WarningAccountIcon;
